var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty flex flex-col items-center"},[_c('img',{staticClass:"empty-img",attrs:{"src":_vm.emptyIcon}}),_c('div',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('div',{staticClass:"subtitle"},[_vm._v(" "+_vm._s(_vm.subtitle)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }